// extracted by mini-css-extract-plugin
module.exports = {"Button":"_3Iqx1ubZ7rQvTpbCOwvuvT"};